import React, { useState } from 'react'
import { MDBIcon } from 'mdb-react-ui-kit'
import './TableOfContents.component.scss'

/**
 * Recursive component to render TOC tree
 */
const TOCItem = ({ item, level = 0 }) => {
  const hasChildren = item.children && item.children.length > 0

  const handleClick = e => {
    e.preventDefault()
    const element = document.getElementById(item.slug)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <li className={`toc-item toc-item--level-${level}`}>
      <a href={`#${item.slug}`} onClick={handleClick} className='toc-link'>
        {item.text}
      </a>
      {hasChildren && (
        <ul className='toc-list'>
          {item.children.map((child, index) => (
            <TOCItem key={index} item={child} level={level + 1} />
          ))}
        </ul>
      )}
    </li>
  )
}

/**
 * Table of Contents Component
 * Displays a hierarchical navigation of document headings
 */
const TableOfContents = ({ toc }) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  if (!toc || toc.length === 0) {
    return null
  }

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <div className={`table-of-contents ${isCollapsed ? 'collapsed' : ''}`}>
      <div className='toc-header' onClick={toggleCollapse}>
        <h4 className='toc-title'>
          <MDBIcon icon='list-ul' className='mr-2' />
          Table of Contents
        </h4>
        <MDBIcon icon={isCollapsed ? 'chevron-down' : 'chevron-up'} className='toc-toggle-icon' />
      </div>
      {!isCollapsed && (
        <nav className='toc-content'>
          <ul className='toc-list'>
            {toc.map((item, index) => (
              <TOCItem key={index} item={item} level={0} />
            ))}
          </ul>
        </nav>
      )}
    </div>
  )
}

export default TableOfContents
